import type { RestoreBackupRequest } from "../api/storage.types";
import { useBusEmitterListener } from "../bridge";

interface DocumentBackupPayloadStart {
  event: "restore";
  request: RestoreBackupRequest;
}
interface DocumentBackupPayloadStarted {
  event: "started";
  shortcut: string;
}

interface DocumentBackupPayloadFinished {
  event: "finished";
  shortcut: string;
}

type DocumentBackupPayload = DocumentBackupPayloadStart | DocumentBackupPayloadStarted | DocumentBackupPayloadFinished;

const loadingFailedEvent = Symbol("document-backup");
export const {
  emitter: documentBackupEvent,
  listener: onDocumentBackupEvent,
} = useBusEmitterListener<DocumentBackupPayload>(loadingFailedEvent);
